import { combineReducers } from "@reduxjs/toolkit";
import Registerreducer from "../slice/registerSlice";
import Loginreducer from "../slice/loginSlice";
import ParticipantLoginReducer from "../slice/participantLoginSlice";
import CompanyReducer from "../slice/companySlice";
import ParticipantReducer from "../slice/participantSlice";
import WorkshopReducer from "../slice/workshopSlice";
import participantDetailsReducer from "../slice/participantDetailsSlice";
import WorkshopDetails from "../slice/workshopDetailSlice";
import WorkshopAdmin from "../slice/workshopAdminSlice";
import ParticipantDashboard from "../slice/participantDashboardSlice";
import DashboardDetails from "../slice/dashboardDetailsSlice";
import SalesPersonDataReducer from "../slice/salesPersonSlice";
import SalesPersonDetailsReducer from "../slice/salesPersonDetailsSlice";
import AdminDataReducer from "../slice/adminSlice";
import AdminDetailsReducer from "../slice/adminDetailsSlice";
import AllRecentAnswersReducer from "../slice/allRecentAnswersSlice";
import IctDetailsReducer from "../slice/ictDetailsSlice";

const rootReducer = combineReducers({
  RegisterReducer: Registerreducer,
  Loginreducer: Loginreducer,
  ParticipantLoginReducer:ParticipantLoginReducer,
  CompanyReducer: CompanyReducer,
  ParticipantReducer: ParticipantReducer,
  WorkshopReducer: WorkshopReducer,
  participantDetailsReducer: participantDetailsReducer,
  WorkshopDetailsReducer: WorkshopDetails,
  WorkshopAdminReducer: WorkshopAdmin,
  ParticipantDashboardReducer:ParticipantDashboard,
  DashboardDetailsReducer:DashboardDetails,
  SalesPersonDataReducer:SalesPersonDataReducer,
  SalesPersonDetailsReducer:SalesPersonDetailsReducer,
  AdminDataReducer:AdminDataReducer,
  AdminDetailsReducer:AdminDetailsReducer,
  AllRecentAnswersReducer:AllRecentAnswersReducer,
  IctDetailsReducer: IctDetailsReducer
});
export default rootReducer;
